import * as actionTypes from '../actions/Actions';

export const initialState = {
    data: {
        step: 0,
        onboardingData: null
    },
};

// ==============================|| ONBOARDING REDUCER ||============================== //

const onboardingReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GO_TO_NEXT_STEP:
            return {
                ...state,
                data: {
                    ...state.data,
                    step: state.data.step + 1,
                }
            };
        case actionTypes.BACK_TO_PREVIOUS_STEP:
            return {
                ...state,
                data: {
                    ...state.data,
                    step: state.data.step - 1,
                }
            };
        case actionTypes.BACK_TO_FIRST_STEP:
            return {
                ...state,
                data: {
                    ...state.data,
                    step: 0,
                }
            };
        case actionTypes.UPDATE_ONBOARDING_DATA:
            return {
                ...state,
                data: {
                    ...state.data,
                    onboardingData: action.onboardingData
                }
            };
        default:
            return state;
    }
};

export default onboardingReducer;
